var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommonIconUploadFile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5837 38.6667V18.9708L20.3003 25.2542L16.917 21.75L29.0003 9.66666L41.0837 21.75L37.7003 25.2542L31.417 18.9708V38.6667H26.5837ZM14.5003 48.3333C13.1712 48.3333 12.0337 47.8605 11.088 46.9147C10.1423 45.969 9.6686 44.8308 9.66699 43.5V36.25H14.5003V43.5H43.5003V36.25H48.3337V43.5C48.3337 44.8292 47.8608 45.9674 46.9151 46.9147C45.9694 47.8621 44.8311 48.3349 43.5003 48.3333H14.5003Z",
    fill: "#949699"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonIconUploadFile);
export default __webpack_public_path__ + "static/media/common_icon_upload_file.17afa37791b48a4802d460e9811abcb1.svg";
export { ForwardRef as ReactComponent };